// extracted by mini-css-extract-plugin
module.exports = {"title":"mobileTitle_title__A4r3m","icon":"mobileTitle_icon__1KVeV","tick":"mobileTitle_tick__3KIRL mobileTitle_icon__1KVeV"};